module.exports = __webpack_public_path__ + "static/media/ils_esign_success_fisdom.dc9dd93a.svg";